<div class="bc-header-button"
     appMenuFocusHandler
     #focusHandler="menuFocusHandler"
     [ngClass]="serviceClass"
     [class.locked-operator-status]="isLocked"
     [class.custom-operator-status]="isCustomStatus"
     [title]="customStatusName | translate"
     [attr.data-automation-id]="'operator-service-status-' + serviceKey">
  <button class="bc-button-inner header-menu-link header-button-box"
          appMenuFocusParent
          (click)="changeStatus.emit()"
          attr.data-automation-id="bc-change-{{ serviceType }}-status">
    <div class="icon-container">
      <svg-icon [icon]="buttonIconByService"
                attr.data-automation-id="bc-{{ serviceType }}-status-icon"></svg-icon>
      <div class="background-circle"></div>
      <svg-icon icon="star"></svg-icon>
      <svg-icon icon="lock"></svg-icon>
    </div>
  </button>

  <div class="status-toggle" *ngIf="hasDropdown">
    <app-navbar-scrollable-dropdown>
      <ng-container header-content>
        <ng-container *ngIf="!isOmniQueue">
          <span class="list-header-label">{{ serviceTranslationKey | translate}}</span>
          <span class="list-header-additional-channels" *ngIf="serviceType === additionalChannelServiceType">
      - <span class="list-header-additional-channel" *ngFor="let channel of additionalChannels">{{ channel }}</span>
    </span>
        </ng-container>
        <div *ngIf="isOmniQueue" class="list-header-omni-queue">
          <span class="omni-channel" *ngFor="let channelInOmni of channelsIncludedInOmniQueue">{{ channelInOmni | translate }}</span>
          <ng-container *ngIf="shouldDisplayAdditionalChannels">
            <span class="omni-channel" *ngFor="let channel of additionalChannels">{{ channel }}</span>
          </ng-container>
        </div>
      </ng-container>

      <ng-container list-content>
        <div *ngFor="let status of statusList">
          <app-navbar-status-dropdown-item #dropdownItem
                                           [name]="status.name"
                                           appMenuFocusTarget
                                           [focusTarget]="dropdownItem"
                                           [focusHandler]="focusHandler"
                                           [isFocusable]="focusHandler.isFocusable"
                                           [inactive]="isServiceLocked || !status.operatorCanChange"
                                           [selected]="status === selectedStatus"
                                           [available]="status.statusType === statusTypes.AVAILABLE"
                                           [away]="status.statusType === statusTypes.AWAY"
                                           (select)="setStatus(status)">
          </app-navbar-status-dropdown-item>
        </div>
      </ng-container>
    </app-navbar-scrollable-dropdown>
  </div>
</div>
